import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import {goBack} from "../../fn/navigation";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";
import StructuresForm from "../../components/Structures/StructuresForm";

const StructuresEdit = ({classes, structure, machines, formUrl, redirectAfterSubmit}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('structures.edit_structure')}
            items={[
                {
                    icon: 'arrow_back',
                    text: i18n.get('schedules.back'),
                    href: `/structures`,
                    onClick: (event) => {
                        event.preventDefault();
                        goBack(`/structures`);
                    },
                }
            ]}
        />

        <Card>
            <CardContent>
                <StructuresForm
                    values={structure}
                    machines={machines}
                    formUrl={formUrl}
                    isEdit={true}
                    redirectAfterSubmit={redirectAfterSubmit}
                />
            </CardContent>
        </Card>
    </Layout>
);

export default StructuresEdit;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/structures/Edit.jsx